export default "__VITE_ASSET__CUxZ5N7b__"